import { useState } from "react";

export default function DevBar() {
  const [visible, setVisible] = useState(true);
  return (
    <>
      {visible ? (
        <div
          style={{
            position: "fixed",
            border: "5px solid orange",
            width: "100%",
            height: "100%",
          }}
        >
          <span
            style={{
              position: "fixed",
              bottom: 0,
              left: 0,
              background: "orange",
              borderRadius: "5px",
              padding: "2px 10px",
              fontWeight: "bold",
              fontSize: "11px",
              display: "inline-block",
              cursor: "pointer",
            }}
            onClick={() => setVisible(false)}
          >
            DEVELOPMENT
          </span>
        </div>
      ) : null}
    </>
  );
}
